<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="sec in sections" :key="sec.type" :label="sec.label" :name="sec.type">
        <el-form label-width="260px" size="small" style="max-width: 760px; margin-top: 10px;">
          <template v-for="(item, idx) in sec.items">
            <el-divider v-if="item.group && item.group !== groupOf(sec.items, idx - 1)"
                        :key="sec.type + '-div-' + item.key" content-position="left">{{ item.group }}</el-divider>
            <el-form-item :key="sec.type + '-' + item.key" :label="item.label">
              <el-input v-model="forms[sec.type][item.key]"
                        :show-password="item.secret"
                        style="max-width: 420px;"></el-input>
            </el-form-item>
          </template>
          <el-form-item>
            <el-button type="primary" size="small" :loading="saving" @click="doSave(sec)">保 存</el-button>
            <span class="save-tip">保存后即时生效；密钥可点击右侧眼睛查看</span>
          </el-form-item>
          <el-form-item v-if="sec.type === 'MAIL'">
            <el-input v-model="testTo" placeholder="测试收件邮箱" style="max-width: 240px;"></el-input>
            <el-button size="small" :loading="testing" @click="doMailTest(sec)" style="margin-left: 12px;">发送测试邮件</el-button>
            <span class="save-tip">用上方当前填写值发送（未保存的修改也会参与测试）</span>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {getIntegrationSetting, saveIntegrationSetting, sendMailTest} from "@/api/setting-api";

export default {
  name: "IntegrationSettingPage",
  data() {
    return {
      activeName: "QYWX",
      sections: [],
      forms: {},
      saving: false,
      testTo: "",
      testing: false,
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      getIntegrationSetting().then(({data}) => {
        if (data.code !== 200) {
          this.$message.error(data.msg || "加载失败")
          return
        }
        this.sections = data.data || []
        const forms = {}
        this.sections.forEach(sec => {
          const f = {}
          sec.items.forEach(it => {
            f[it.key] = it.value || ""
          })
          forms[sec.type] = f
        })
        this.forms = forms
      }).catch(err => {
        console.log("getIntegrationSetting err", err)
        this.$message.error("加载失败")
      })
    },

    doSave(sec) {
      this.saving = true
      saveIntegrationSetting({type: sec.type, values: this.forms[sec.type]}).then(({data}) => {
        this.saving = false
        if (data.code === 200) {
          this.$message.success("保存成功，已生效")
          this.load()
        } else {
          this.$message.error(data.msg || "保存失败")
        }
      }).catch(err => {
        console.log("saveIntegrationSetting err", err)
        this.saving = false
        this.$message.error("保存失败")
      })
    },

    doMailTest(sec) {
      const to = (this.testTo || "").trim()
      if (!to || !to.includes("@")) {
        this.$message.error("请填写正确的测试收件邮箱")
        return
      }
      this.testing = true
      sendMailTest({to, values: this.forms[sec.type]}).then(({data}) => {
        this.testing = false
        if (data.code === 200) {
          this.$message.success("测试邮件已发送，请到收件箱查收")
        } else {
          this.$message.error(data.msg || data.data && data.data.message || "发送失败")
        }
      }).catch(err => {
        console.log("sendMailTest err", err)
        this.testing = false
        const msg = err && err.response && err.response.data && err.response.data.msg
        this.$message.error(msg || "发送失败")
      })
    },

    groupOf(items, idx) {
      if (idx < 0) return ""
      return items[idx].group || ""
    },
  },
}
</script>

<style scoped lang="less">
.save-tip {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}
</style>
